// extracted by mini-css-extract-plugin
export var container = "_e8-1";
export var cornerButtonContainer = "_e8-6";
export var disabled = "_e8-2";
export var dragActive = "_e8-3";
export var fileContainer = "_e8-5";
export var hiddenInput = "_e8-4";
export var widthContainer = "_e8-0";